// import external dependencies
import 'jquery';

// Import Slick
// import 'slick-carousel/slick/slick.min';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import slick from './routes/slick';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // Slick slider
  slick,
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$( document ).ready(function() {
// Accessibility for Header

var MegaMenuAlt = 1;
$(".mega-menu .mega-menu-item img").each(function(){
  $(this).attr("alt","mega menu product "+ MegaMenuAlt);
  MegaMenuAlt++;
})

// accessibility for home page 

  $(".hero-slide").removeAttr("aria-hidden");
  $("label.screen-reader-text").attr("aria-label","products search");
  $("[for='mce-email']").attr("aria-label","email address");
  $("[for='user_login']").attr("aria-label","username or email address");
  $("[for='user_pass']").attr("aria-label","user password");
  $(".login-remember label").attr("aria-label","rememberme");
  $("[name='your-recipient']").attr("aria-label","contact");
  $("[name='customer-type']").attr("aria-label","customer type");
  setInterval(function() {
    $(".ddc-product-image-slider .slick-prev").attr("alt","ddc slider arrow prev");
    $(".ddc-product-image-slider .slick-next").attr("alt","ddc slider arrow next");
    $(".single_ button").attr("aria-label","add to wishlist");
  }, 200);
  // $(".ddc-product-search [type='search']").attr("tabindex","-1");
  
  // accessibility for home page 
  $(".template-about .single-image img").attr("alt","single image");

  // accessibility product details page 
  $(".ddc-back-btn").attr("aria-label","back button");
  $(".breadcrumb-links a").attr("aria-label","link button");
  $(".ddc-attribute-value a").attr("aria-label","link button");
  
  // accessibility cart page 
  $(".shipping-calculator-button").attr("aria-label","calculate shipping");
  $(".shipping-calculator-form select").attr("aria-label","select dropdown");
  $("#calc_shipping_city_field input").before("<label for='calc_shipping_city' class='dummy-label'>Town / City</label>");
  $("#calc_shipping_postcode_field input").before("<label for='calc_shipping_postcode' class='dummy-label'>ZIP Code</label>");
  $("#woocommerce-shipping-calculator-nonce").before("<label for='woocommerce-shipping-calculator-nonce' class='dummy-label'>calculator</label>");
  $("[name='_wp_http_referer']").before("<label for='_wp_http_referer' class='dummy-label'>referer</label>");
  $(".wc-proceed-to-checkout").attr("aria-label","Proceed to checkout");
  var productThumbnail = 1;
  $(".product-thumbnail img").each(function(){
    $(this).attr("alt","product thumbnail "+ productThumbnail);
    productThumbnail++;
  })
  
  // accessibility All Stock page 
  setInterval(function() {
    $(".lmp_button").attr("aria-label","Load Previous");
    $(".show-prices .products a").attr("aria-label","Product Link");
    $(".show-prices .products img").attr("alt","Product Thumb");
    $(".page-numbers a").attr("aria-label","Page Link");
  }, 200);
  
  // accessibility projects page 
  $(".share-links a").attr("aria-label","share links");
  $(".post-summary .post-img a").attr("aria-label","post links");
  $(".nav-links a").attr("aria-label","nav links");
  
  // accessibility contact page 
  $(".contact-col-six a").attr("aria-label","link");
  $(".contact-col-six [name='first-name']").attr("id","firstname").before("<label for='firstname' class='dummy-label'>first name</label>");
  $(".contact-col-six [name='last-name']").attr("id","lastname").before("<label for='lastname' class='dummy-label'>first name</label>");
  $(".contact-col-six [name='customer-type']").attr("id","customertype").before("<label for='customertype' class='dummy-label'>customer type</label>");
  $(".contact-col-six [name='company']").attr("id","company_input").before("<label for='company_input' class='dummy-label'>company</label>");
  $(".contact-col-six [name='email-add']").attr("id","emailadd").before("<label for='emailadd' class='dummy-label'>email</label>");
  $(".contact-col-six [name='phone']").attr("id","phone_input").before("<label for='phone_input' class='dummy-label'>phone</label>");
  $(".contact-col-six [name='your-recipient']").attr("id","yourrecipient").before("<label for='yourrecipient' class='dummy-label'>your recipient</label>");
  $(".contact-col-six [name='inquiry']").attr("id","inquiry_input").before("<label for='inquiry_input' class='dummy-label'>inquiry</label>");
  $(".contact-col-six [name='inquire-message']").attr("id","inquire-message").before("<label for='inquire-message' class='dummy-label'>inquire message</label>");
  $(".contact-col-six [name='inquiry']").attr("aria-label","How Can We Help You");
  
  // accessibility checkout page 
  $(".showlogin").attr("aria-label","login link");
  $(".lost_password").attr("aria-label","lost password link");
  $(".showcoupon").attr("aria-label","show coupon link");
  $("[name='coupon_code']").before("<label for='coupon_code' class='dummy-label'>coupon code</label>");
  $(".woocommerce-privacy-policy-text").attr("aria-label","woocommerce link");
  
    // accessibility order tracking page 
    $(".tracking-share .g-recaptcha #g-recaptcha-response").before("<label for='g-recaptcha-response' class='dummy-label'>recaptcha</label>");
  
  jQuery(document).on("keyup", function(e) {
    if (jQuery("[aria-label='cart']").is(":focus")) {
      var code = (e.keyCode ? e.keyCode : e.which);
      if (code == 9) {
        jQuery('.ddc-search-toggle').trigger('click');
      }
    }
  });

  jQuery('button.dgwt-wcas-search-submit').blur( function() {
    jQuery('div.ddc-search-close').trigger('click');
  });
 
});


// WEBPACK FOOTER //
// ./scripts/main.js